import React from 'react';
import {Grid, Typography, FormControl} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {useForm} from 'react-hook-form';
import {makeStyles} from '@material-ui/core/styles';
import SubscribedServices from './SubscribedServices';
import inputStyles from '../../components/InputStyles';
import UnsubscribedServices from './UnsubscribedServices';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },
}));

const ClientService = () => {
  const classes = inputStyles();
  const classes1 = useStyles();

  const initialValues = {
    company: '',
    parent: '',
    client: '',
  };

  const {handleSubmit, control} = useForm({
    defaultValues: initialValues,
  });

  const onSubmit = (data) => {};

  return (
    <div>
      <div className={classes.cardStyling}>
        <div className="mt-2">
          <Typography variant="h4" className="px-2">View Rate Card for Client / Hospital Services</Typography>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container className="mt-3">
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={[]}
                      getOptionLabel={(option) => option?.client_id}
                      getOptionSelected={(option, value) =>
                        value === undefined || value === '' || option.client_id === value.client_id
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="Company"
                          placeholder="Select Company"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="company"
                  control={control}
                />
              </FormControl>
            </Grid>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={[]}
                      value={''}
                      getOptionLabel={(option) => option.service_type}
                      getOptionSelected={(option, value) =>
                        value === undefined ||
                        value === '' ||
                        option.service_type === value.service_type
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="Parent"
                          placeholder="Select Parent"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => props.onChange(data)}
                    />
                  )}
                  name="parent"
                  control={control}
                />
              </FormControl>
            </Grid>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={[]}
                      value={''}
                      getOptionLabel={(option) => option.service_type}
                      getOptionSelected={(option, value) =>
                        value === undefined ||
                        value === '' ||
                        option.service_type === value.service_type
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="Client"
                          placeholder="Select Client"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => props.onChange(data)}
                    />
                  )}
                  name="client"
                  control={control}
                />
              </FormControl>
            </Grid>
          </Grid>
        </form>
        <Typography variant="h4" className="col-md-12">
          Subscribed Services
        </Typography>
        <div className={classes1.root}>
          <SubscribedServices />
        </div>
        <Typography variant="h4" className="col-md-12 mt-3">
          Services Not Subscribed
        </Typography>
        <div className={classes1.root}>
          <UnsubscribedServices />
        </div>
      </div>
      {/* {isLoadingView && <PageLoader />} */}
    </div>
  );
};

export default ClientService;
